import { useMemo } from 'react';
import star from '~/assets/icons/four_final_star.svg';
import { CollectionImage } from '~/components/collections';
import { ClothesImage } from '~/components/collections/ClothesImage';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { ParseRewardValueTypeMap, RewardType, isClothesItem } from '~/shared';
import cardSoft from '../../assets/images/cases/card_soft.png';
import {
	StyledContainer,
	StyledExpContainer,
	StyledImageContainer,
	StyledShadow,
	StyledText,
} from './ShopKitOpenItem.styled';

const ShopKitOpenItem = ({
	type,
	name,
	id,
}: {
	type: RewardType;
	name: string;
	id?: string;
}) => {
	const lootboxes = useObservable(rage.cases.getLootboxes());
	const lootbox = useMemo(() => {
		return lootboxes.find((caseItem) => caseItem.donateItemId === id);
	}, [lootboxes, id]);

	const reward = useMemo(() => {
		if (!id) {
			return null;
		}

		return rage.cases.getRewardById(id);
	}, [id]);

	const amount = useMemo(() => {
		if (!reward) {
			return 0;
		}

		if (type === RewardType.EXP) {
			return (reward.value as ParseRewardValueTypeMap[RewardType.EXP]) ?? 0;
		}
		if (type === RewardType.MONEY) {
			return (reward.value as ParseRewardValueTypeMap[RewardType.MONEY]) ?? 0;
		}

		return 0;
	}, [reward]);

	return (
		<StyledContainer>
			<StyledShadow />
			<StyledText>{rage.cases.getRewardNameById(name)}</StyledText>
			<StyledImageContainer $type={type}>
				{type === RewardType.VEHICLE && id ? (
					<CollectionImage collection={'vehicles'} id={id} size={120} />
				) : null}
				{type === RewardType.ITEM && id ? (
					isClothesItem(id) ? (
						<ClothesImage id={id} size={120} />
					) : (
						<CollectionImage collection={'items'} id={id} size={120} />
					)
				) : null}
				{type === RewardType.MONEY && (
					<img src={cardSoft} width={140} height={140} />
				)}
				{type === RewardType.EXP && (
					<StyledExpContainer>
						<ImgIcon icon={star} width={30} height={30} color="#FFB500" />
						<Text>{amount.toLocaleString('ru-RU')}</Text>
					</StyledExpContainer>
				)}
				{type === RewardType.LOOTBOX && (
					<CollectionImage
						collection={'cases'}
						id={lootbox?.id ?? id ?? ''}
						size={250}
					/>
				)}
			</StyledImageContainer>
		</StyledContainer>
	);
};

export { ShopKitOpenItem };
